import { normalizeAllowedRedirectPath } from "@miadvg/auth-gateway";

export const TEMPLATE_STAFF_APP_SLUG = "salessupport";
export const TEMPLATE_STAFF_AUTH_CALLBACK_PATH = "/auth/callback";
export const TEMPLATE_STAFF_SIGN_OUT_PATH = "/api/auth/sign-out";

export function normalizeTemplateStaffRedirectPath(
  rawValue: string | null | undefined,
): string {
  return normalizeAllowedRedirectPath(rawValue, {
    fallback: "/8821",
    allowedPrefixes: ["/staff", "/8821", "/tia", "/campaigns", "/browser"],
  });
}
